// GTM loads FullStory asynchronously. On page reload with an already-authenticated
// user, window.FS may not exist yet when processToken fires during app bootstrap.
// A single shared interval ensures only the latest pending action executes,
// preventing a race where identify and anonymize both queue up and fire out of order.
let pendingFn: ((fs: FullStory) => void) | null = null;
let pollingInterval: ReturnType<typeof setInterval> | null = null;

function withFS(fn: (fs: FullStory) => void): void {
  if (window.FS) {
    pendingFn = null;
    fn(window.FS);
    return;
  }
  pendingFn = fn;
  if (pollingInterval !== null) {
    return;
  }
  let attempts = 0;
  pollingInterval = setInterval(() => {
    if (window.FS) {
      clearInterval(pollingInterval!);
      pollingInterval = null;
      pendingFn?.(window.FS);
      pendingFn = null;
    } else if (++attempts >= 20) {
      clearInterval(pollingInterval!);
      pollingInterval = null;
      pendingFn = null;
    }
  }, 250);
}

export function identifyUserInFullStory(userId: string | undefined, displayName: string | undefined, email: string | undefined): void {
  if (!userId) return;
  const vars: Record<string, string> = {};
  if (displayName) vars.displayName = displayName;
  if (email) vars.email = email;
  withFS((fs) => fs.identify(userId, vars));
}

export function anonymizeInFullStory(): void {
  withFS((fs) => fs.anonymize());
}
